import styled from "styled-components";
import {useState} from "react";
import {X} from "lucide-react";
import storage from "../utils/storage";
import {useStoreProfile} from "../store";
import {themecolors} from "../utils/themecolors";
import useModal from "../modals";
import Sheet from "./bottom-sheet/sheet";
import CommunitySuggestionsSheet from "./bottom-sheet/community_suggestions";

const Container = styled.div``;
const Heading = styled.div``;
const Description = styled.div``;
const List = styled.div``;
const Save = styled.div``;
const Close = styled.button``;
const Topic = styled.div``;

const HomeCommunitySuggestions = styled(({className}) => {
    const modal = useModal();
    const {expand} = useStoreProfile();
    const [dismissed, setDismissed] = useState(() => storage.getItem("dismissedHomeCommunitySuggestions"));
    const handleDismiss = () => {
        storage.setItem("dismissedHomeCommunitySuggestions", true);
        setDismissed(true);
    }

    const [suggestionsOpen, setSuggestionsOpen] = useState(false);
    const [selectedTopic, setSelectedTopic] = useState('');
    const handleOpen = (topic) => {
        setSelectedTopic(topic);
        setSuggestionsOpen(true);
    }
    return !dismissed && (
        <Container className={className} style={{marginBottom: 0, borderBottomWidth: expand === 'card' ? 0 : 1, borderTopWidth: expand === 'card' ? 1 : 0}}>
            <Heading>Customize your home feed</Heading>
            <Description>Select topics that you're interested in</Description>
            <List>
                <Topic onClick={() => handleOpen('Funny')}>
                    Funny
                </Topic>
                <Topic onClick={() => handleOpen('Edgy Humor')}>
                    Edgy Humor
                </Topic>
                <Topic onClick={() => handleOpen('Nature')}>
                    Nature
                </Topic>
                <Topic onClick={() => handleOpen('Counterculture')}>
                    Counterculture
                </Topic>
                <Topic onClick={() => handleOpen('Cringe')}>
                    Cringe
                </Topic>
                <Topic onClick={() => handleOpen('Weird')}>
                    Weird
                </Topic>
                <Topic onClick={() => handleOpen('Left-wing Politics')}>
                    Left-wing Politics
                </Topic>
                <Topic onClick={() => handleOpen('Videos')}>
                    Videos
                </Topic>
                <Topic onClick={() => handleOpen('Right-wing Politics')}>
                    Right-wing Politics
                </Topic>
            </List>
            <Close onClick={handleDismiss}>
                <X size={20} />
            </Close>
            {suggestionsOpen && <Sheet onClose={() => setSuggestionsOpen(false) } padding={"header"}><CommunitySuggestionsSheet selectedTopic={selectedTopic} onClose={() => setSuggestionsOpen(false) } /></Sheet>}
        </Container>
    );
})`
  position: relative;
  padding: 20px;
  border-top: 0px solid ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_5 : themecolors.lighter_border};
  border-bottom: 0px solid ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_5 : themecolors.lighter_border};
  background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_1 : theme.white_0};
  ${List} {
    display: flex;
    padding-top: 12px;
    flex-wrap: wrap;
  }
  ${Topic} {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
    padding: 6px 16px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_5 : '#ececec'};
    border-radius: 40px;
    margin-right: 6px;
    margin-bottom: 6px;
    font-weight: 500;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
  }
  ${Heading} {
    font-size: 19px;
    font-weight: 600;
    height: 29px;
  }
  ${Description} {
    font-size: 15px;
    padding-bottom: 6px;
    line-height: 24px;
  }
  ${Topic}.active {
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_6 : '#eaeaea'};
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : 'inherit'};
  }
  ${Save} {
    margin-top: 12px;
    display: flex;
    justify-content: end;
  }
  ${Close} {
    position: absolute;
    top: 24px;
    right: 24px;
  }
  ${Close} svg {
    fill: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_low_impact_text : '#e9e9ec'};
  }
  ${Close} svg:hover {
    fill: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : '#000'};
  }
`;

export default HomeCommunitySuggestions;